import React from 'react';
import MainHeader from './MainHeader';   // <--- This fixes the error!
import StaffHeader from './StaffHeader'; // <--- This fixes the error!
import Auth from '../Common/Configurations/Auth';

const Navbar = () => {
    const userRole = Auth.getRole();
    
    // Log this so you can see it in the F12 console
    console.log("Navbar detecting role:", userRole);

    if (userRole === "Admin") {
        return <MainHeader />;
    } 
    
    // If it's Staff, or anything else, show StaffHeader
    return <StaffHeader />;
};

export default Navbar;